import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {getPhasenVeranstaltungFunktionsbereiche} from './funktionsbereich-checklisten.reducer';
import {filter, map, withLatestFrom} from 'rxjs/operators';
import {PAGE_DATEN_LADEN, PageLoadDataAction} from './funktionsbereich-checklisten.actions.ui';
import {GetVeranstaltungFunktionsbereicheChecklistenAction} from '../../../../client-ngrx/veranstaltungen';
import {
    Checkliste,
    ChecklisteStatus,
    Dokument,
    FunktionsbereichStatus,
    PhasenVeranstaltungFunktionsbereiche,
    Veranstaltung,
    VeranstaltungStatus
} from '../../../../clients/veranstaltungen';
import {WS_READ_MODEL_UPDATED, WsReadModelUpdatedAction} from '../../../websocket.actions';
import {VeranstaltungenEntityTypes} from '../../../../client-constants';
import {getAktuelleVeranstaltung} from '../../app-state/app-state.reducer';

import VERANSTALTUNG_ENTITY_PART_STATUS = VeranstaltungenEntityTypes.VERANSTALTUNG_ENTITY_PART_STATUS;
import FUNKTIONSBEREICH_ENTITY_PART_STATUS = VeranstaltungenEntityTypes.FUNKTIONSBEREICH_ENTITY_PART_STATUS;
import CHECKLISTE_ENTITY = VeranstaltungenEntityTypes.CHECKLISTE_ENTITY;
import CHECKLISTE_ENTITY_PART_STATUS = VeranstaltungenEntityTypes.CHECKLISTE_ENTITY_PART_STATUS;
import {
    AKTUELLE_VERANSTALTUNG_SETZEN,
    AktuelleVeranstaltungSetzenAction
} from '../../app-state/actions/veranstaltung.actions';
import VERANSTALTUNG_ENTITY = VeranstaltungenEntityTypes.VERANSTALTUNG_ENTITY;
import FUNKTIONSBEREICH_ENTITY = VeranstaltungenEntityTypes.FUNKTIONSBEREICH_ENTITY;

@Injectable()
export class FunktionsbereicheChecklistenPageUiEffects {

    @Effect()
    datenLaden$: Observable<Action> = this.actions$.pipe(
        ofType(PAGE_DATEN_LADEN),
        withLatestFrom(this.store$.pipe(select(getAktuelleVeranstaltung))),
        filter(([x, aktuelleVeranstaltung]: [PageLoadDataAction, Veranstaltung]) => aktuelleVeranstaltung !== null),
        map(([x, aktuelleVeranstaltung]: [PageLoadDataAction, Veranstaltung]) =>
            new GetVeranstaltungFunktionsbereicheChecklistenAction(aktuelleVeranstaltung.veranstaltung_id)
        )
    );

    @Effect()
    aktuelleVeranstaltungSetzen$: Observable<Action> = this.actions$.pipe(
        ofType(AKTUELLE_VERANSTALTUNG_SETZEN),
        map((x: AktuelleVeranstaltungSetzenAction) => x),
        filter(x => x.payload != null),
        map(x => x.payload),
        filter(x => x.veranstaltung_id != null),
        map(x => new GetVeranstaltungFunktionsbereicheChecklistenAction(x.veranstaltung_id))
    );

    // @Effect()
    // wsVeranstaltung$: Observable<any> = this.actions$.pipe(
    //     ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED),
    //     filter((x: WsReadModelUpdatedAction) => {
    //         return x.message.entity_type.toUpperCase() === VERANSTALTUNG_DETAIL;
    //     }),
    //     map((x) => <Veranstaltung>JSON.parse(x.message.entity)),
    //     withLatestFrom(this.store$.pipe(select(getAktuelleVeranstaltung))),
    //     filter(([x, aktuelleVeranstaltung]: [Veranstaltung, Veranstaltung]) => aktuelleVeranstaltung !== null),
    //     filter(([x, aktuelleVeranstaltung]: [Veranstaltung, Veranstaltung]) => aktuelleVeranstaltung.veranstaltung_id === x.veranstaltung_id),
    //     map(([x, aktuelleVeranstaltung]: [Veranstaltung, Veranstaltung]) =>
    //         new GetVeranstaltungFunktionsbereicheChecklistenAction(aktuelleVeranstaltung.veranstaltung_id)
    //     )
    // );

    @Effect()
        // wsVeranstaltungStatus$: Observable<Action> = this.actions$.pipe(
    wsVeranstaltungStatus$: Observable<any> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED),
        filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === VERANSTALTUNG_ENTITY && x.message.entity_part.toUpperCase() === VERANSTALTUNG_ENTITY_PART_STATUS;
        }),
        map((x) => <VeranstaltungStatus>JSON.parse(x.message.entity)),
        withLatestFrom(this.store$.pipe(select(getAktuelleVeranstaltung))),
        filter(([x, aktuelleVeranstaltung]: [VeranstaltungStatus, Veranstaltung]) => aktuelleVeranstaltung !== null),
        filter(([x, aktuelleVeranstaltung]: [VeranstaltungStatus, Veranstaltung]) => aktuelleVeranstaltung.veranstaltung_id === x.veranstaltung_id),
        map(([x, aktuelleVeranstaltung]: [VeranstaltungStatus, Veranstaltung]) =>
            new GetVeranstaltungFunktionsbereicheChecklistenAction(aktuelleVeranstaltung.veranstaltung_id)
        )
    );

    @Effect()
    wsFunktionsbereichStatus$: Observable<any> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED),
        filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === FUNKTIONSBEREICH_ENTITY && x.message.entity_part.toUpperCase() === FUNKTIONSBEREICH_ENTITY_PART_STATUS;
        }),
        map((x) => <FunktionsbereichStatus>JSON.parse(x.message.entity)),
        withLatestFrom(this.store$.pipe(select(getAktuelleVeranstaltung))),
        filter(([x, aktuelleVeranstaltung]: [FunktionsbereichStatus, Veranstaltung]) => aktuelleVeranstaltung !== null),
        filter(([x, aktuelleVeranstaltung]: [FunktionsbereichStatus, Veranstaltung]) => aktuelleVeranstaltung.veranstaltung_id === x.veranstaltung_id),
        withLatestFrom(this.store$.pipe(select(getPhasenVeranstaltungFunktionsbereiche))),
        filter(([[x, aktuelleVeranstaltung], phasenVeranstaltungFunktionsbereiche]: [[FunktionsbereichStatus, Veranstaltung], PhasenVeranstaltungFunktionsbereiche[]]) => {
            let found = false;
            if (phasenVeranstaltungFunktionsbereiche !== null) {
                const fbChecklisten: Array<PhasenVeranstaltungFunktionsbereiche> = phasenVeranstaltungFunktionsbereiche;
                fbChecklisten.forEach(fbCl => {
                    const i = fbCl.funktionsbereiche.findIndex(fb => fb.funktionsbereich.funktionsbereich_id === x.funktionsbereich_id);
                    if (i !== -1) {
                        found = true;
                    }

                });
            }

            return found;
        }),
        map(([[x, aktuelleVeranstaltung], phasenVeranstaltungFunktionsbereiche]: [[FunktionsbereichStatus, Veranstaltung], PhasenVeranstaltungFunktionsbereiche[]]) =>
            new GetVeranstaltungFunktionsbereicheChecklistenAction(aktuelleVeranstaltung.veranstaltung_id)
        )
    );

    @Effect()
        // wsCheckliste$: Observable<Action> = this.actions$.pipe(
    wsCheckliste$: Observable<any> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED),
        filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === CHECKLISTE_ENTITY && x.message.entity_part.toUpperCase() !== CHECKLISTE_ENTITY_PART_STATUS;
        }),
        map((x) => <Checkliste>JSON.parse(x.message.entity)),
        withLatestFrom(this.store$.pipe(select(getAktuelleVeranstaltung))),
        filter(([x, aktuelleVeranstaltung]: [Checkliste, Veranstaltung]) => aktuelleVeranstaltung !== null),
        filter(([x, aktuelleVeranstaltung]: [Checkliste, Veranstaltung]) => aktuelleVeranstaltung.veranstaltung_id === x.veranstaltung_id),
        withLatestFrom(this.store$.pipe(select(getPhasenVeranstaltungFunktionsbereiche))),
        filter(([[x, aktuelleVeranstaltung], phasenVeranstaltungFunktionsbereiche]: [[Checkliste, Veranstaltung], PhasenVeranstaltungFunktionsbereiche[]]) => {
            return phasenVeranstaltungFunktionsbereiche !== null;
        }),
        filter(([[x, aktuelleVeranstaltung], phasenVeranstaltungFunktionsbereiche]: [[Checkliste, Veranstaltung], PhasenVeranstaltungFunktionsbereiche[]]) => {
            let found = false;
            if (phasenVeranstaltungFunktionsbereiche !== null) {
                const fbChecklisten: Array<PhasenVeranstaltungFunktionsbereiche> = phasenVeranstaltungFunktionsbereiche;
                fbChecklisten.forEach(fbCl => {

                    fbCl.funktionsbereiche.forEach(fb => {

                        const i = fb.checklisten.findIndex(cl => cl.checkliste.checkliste_id === x.checkliste_id);
                        if (i !== -1) {
                            found = true;
                        }
                    });
                });
            }
            return found;
        }),
        map(([[x, aktuelleVeranstaltung], phasenVeranstaltungFunktionsbereiche]: [[Checkliste, Veranstaltung], PhasenVeranstaltungFunktionsbereiche[]]) =>
            new GetVeranstaltungFunktionsbereicheChecklistenAction(aktuelleVeranstaltung.veranstaltung_id)
        )
    );

    @Effect()
    wsChecklisteStatus$: Observable<any> = this.actions$.pipe(
        ofType<WsReadModelUpdatedAction>(WS_READ_MODEL_UPDATED),
        filter((x: WsReadModelUpdatedAction) => {
            return x.message.entity_type.toUpperCase() === CHECKLISTE_ENTITY && x.message.entity_part.toUpperCase() === CHECKLISTE_ENTITY_PART_STATUS;
        }),
        map((x) => <ChecklisteStatus>JSON.parse(x.message.entity)),
        withLatestFrom(this.store$.pipe(select(getAktuelleVeranstaltung))),
        filter(([x, aktuelleVeranstaltung]: [ChecklisteStatus, Veranstaltung]) => aktuelleVeranstaltung !== null),
        filter(([x, aktuelleVeranstaltung]: [ChecklisteStatus, Veranstaltung]) => aktuelleVeranstaltung.veranstaltung_id === x.veranstaltung_id),
        withLatestFrom(this.store$.pipe(select(getPhasenVeranstaltungFunktionsbereiche))),
        filter(([[x, aktuelleVeranstaltung], phasenVeranstaltungFunktionsbereiche]: [[Checkliste, Veranstaltung], PhasenVeranstaltungFunktionsbereiche[]]) => {
            return phasenVeranstaltungFunktionsbereiche !== null;
        }),
        filter(([[x, aktuelleVeranstaltung], phasenVeranstaltungFunktionsbereiche]: [[Checkliste, Veranstaltung], PhasenVeranstaltungFunktionsbereiche[]]) => {
            let found = false;
            if (phasenVeranstaltungFunktionsbereiche !== null) {
                const fbChecklisten: Array<PhasenVeranstaltungFunktionsbereiche> = phasenVeranstaltungFunktionsbereiche;
                fbChecklisten.forEach(fbCl => {

                    fbCl.funktionsbereiche.forEach(fb => {

                        const i = fb.checklisten.findIndex(cl => cl.checkliste.checkliste_id === x.checkliste_id);
                        if (i !== -1) {
                            found = true;
                        }
                    });
                });
            }

            return found;
        }),
        map(([[x, aktuelleVeranstaltung], phasenVeranstaltungFunktionsbereiche]: [[Checkliste, Veranstaltung], PhasenVeranstaltungFunktionsbereiche[]]) =>
            new GetVeranstaltungFunktionsbereicheChecklistenAction(aktuelleVeranstaltung.veranstaltung_id)
        )
    );


    constructor(private actions$: Actions,
                private store$: Store<any>) {
    }
}
